import React, { useState } from "react";
import PropTypes from "prop-types";

const COLLAPSE_THRESHOLD = 10;

const SelectedPatientsList = ({ selectedRows }) => {
  const [expanded, setExpanded] = useState(
    selectedRows.length <= COLLAPSE_THRESHOLD
  );

  const visible = expanded
    ? selectedRows
    : selectedRows.slice(0, COLLAPSE_THRESHOLD);

  return (
    <div className="patient-outreach-selected-list">
      <ul>
        {visible.map(row => (
          <li key={row.patientGuid}>
            {row.patientName || row.patientGuid}
            {row.patientAccountNumber && ` (${row.patientAccountNumber})`}
          </li>
        ))}
      </ul>
      {selectedRows.length > COLLAPSE_THRESHOLD && (
        <button
          type="button"
          className="patient-outreach-selected-list__toggle"
          onClick={() => setExpanded(e => !e)}
        >
          {expanded
            ? `Show fewer`
            : `Show ${selectedRows.length - COLLAPSE_THRESHOLD} more…`}
        </button>
      )}
    </div>
  );
};

SelectedPatientsList.propTypes = {
  selectedRows: PropTypes.arrayOf(
    PropTypes.shape({
      patientGuid: PropTypes.string.isRequired,
      patientName: PropTypes.string,
      patientAccountNumber: PropTypes.string
    })
  ).isRequired
};

export default SelectedPatientsList;
